// Modules
import { getDiscountPrice, centsToDollar } from './utils/money';
import React, { Fragment, useState } from 'react';

// Styles
import styles from './InvoiceDetails.module.scss';

function InvoiceTable(props) {
  const { total, lineItems, hasDiscount, displayDiscount, discountPrice } =
    props;

  // Why they want a table the looks like butt on small screens is a mystery to me
  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th>Description</th>
          <th>Qty</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {lineItems.map((item, index) => {
          return (
            <Fragment key={`${item.name}-${index}`}>
              <tr>
                <td className={styles.description}>
                  {item.name}
                  {item.description ? ' - ' : ''}
                  {item.description}
                </td>
                <td>{item.quantity}</td>
                <td className={styles.itemPrice}>${item.price}</td>
              </tr>
              <tr className={styles.spacer}></tr>
            </Fragment>
          );
        })}
        {hasDiscount && (
          <Fragment>
            <tr>
              <td className={styles.description}>
                Order discount ({displayDiscount})
              </td>
              <td></td>
              <td className={styles.itemPrice}>{discountPrice}</td>
            </tr>
            <tr className={styles.spacer}></tr>
          </Fragment>
        )}
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td>Total</td>
          <td className={styles.tFootTotal}>${total}</td>
        </tr>
      </tfoot>
    </table>
  );
}

/**
 * ==================
 * EXPORTED COMPONENT
 * ==================
 */
const InvoiceDetails = (props) => {
  const {
    total,
    idObj: { label, value },
    lineItems,
    startExpanded,
    discountAmount,
    discountMethod,
    subTotal,
  } = props;

  const [showFullDetails, setShowFullDetails] = useState(
    startExpanded !== undefined
      ? startExpanded
      : lineItems.length === 1
      ? true
      : false
  );

  const hasDiscount = !!discountAmount;
  const displayDiscount =
    discountMethod === 'amount' ? `$${discountAmount}` : `${discountAmount}%`;

  const discountPrice = `-${getDiscountPrice(
    centsToDollar(subTotal),
    discountAmount,
    discountMethod
  )}`;

  const handleClick = () => {
    setShowFullDetails((state) => {
      /**
       * state ? 'collapsed' : 'expanded'
       * ^^^ This might be confusing at first, here is the explanation:
       * state is a boolean value
       * We toggle it between true and false by returning !state
       *
       * If state === true it means that the details are currently expanded
       * so when we return !state the details will collapse
       *
       * So you can think of the ternary expression as saying,
       * if state is currently true then we are about to collapse the details
       * but if state is currently false we are about to expand the details
       */
      return !state;
    });
  };

  return (
    <section
      className={showFullDetails ? styles.container : styles.containerCollapsed}
    >
      <header className={styles.header}>
        <h3>Amount Due</h3>
        <p className={styles.headerTotal}>${total}</p>
        {value && (
          <p className={styles.id}>
            {label}: {value}
          </p>
        )}
      </header>

      <button className={styles.btn} onClick={handleClick}>
        {showFullDetails ? '-' : '+'} Details
      </button>

      <div>
        {showFullDetails ? (
          <InvoiceTable
            total={total}
            lineItems={lineItems}
            hasDiscount={hasDiscount}
            displayDiscount={displayDiscount}
            discountPrice={discountPrice}
          />
        ) : null}
      </div>
    </section>
  );
};

export default InvoiceDetails;
